import { useState } from 'react';

import { useLocation, useNavigate } from '@reach/router';
import { useDispatch, useSelector } from 'react-redux';

import { fakeDelay, linkCheckSlash } from '../../provider/utility';
import { selectedService } from '../../store/actions';
import { serviceTypes } from '../../store/initData/services';
import FormLabel from '../FormLabel/FormLabel';
import SelectOption from '../SelectOption/SelectOption';
import SingleInputPage from './SingleInputPage/SingleInputPage';
import { selectedCity } from '../../store/actions';

export default function ServicePage(cityId = null) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(false);

  const currentPage = useSelector((store) => store.state.page);
  const currentAge = useSelector((store) => store.state.age);

  const serviceFormLabel = useSelector((store) => store.data.serviceFormLabel);
  const availableServices = useSelector((store) => store.data.services);
  const currentService = useSelector((store) => store.state.service);
  const availableFranchises = useSelector((store) => store.data.franchises);

  //In case of redirect instead of the previous step
  const currentCity = useSelector((store) => store.state.city);
  if (!currentCity) {
    const availableCities = availableFranchises?.map((fr) => ({
      text: fr.name,
      // Remap Gdynia to Gdańsk
      value: (fr.id === 19) ? 3 : fr.id,
      franchise: fr,
    }));
    dispatch(selectedCity(availableCities.find(({id}) => id === cityId)));
  }

  availableServices.find(s => s.value === 'polkolonie').disabled = !currentCity.franchise.summerplay_section_active;

  const ageLinkValue = currentAge?.value || 0;

  const handleSelection = (item) => {
    if (item.value === serviceTypes.birthday) {
      window.open('https://b24-nhof01.bitrix24.site/urodzinkiG4R/', '_blank');
      
      return;
    }
    dispatch(selectedService(item));
    setLoading(true);
    fakeDelay(() => {
      navigate(linkCheckSlash(
        location.pathname,
        item.value === serviceTypes.workshop ? `${item.value}/${ageLinkValue}` : item.value
        )
      );
    });
  };

  const content = (
    <div>
      <FormLabel type="big">{serviceFormLabel}</FormLabel>
      <SelectOption
        items={availableServices}
        selected={currentService}
        onClick={handleSelection}
        displayPrimaryButton={true}
      />
    </div>
  );

  return (
    <SingleInputPage
      setLoading={setLoading}
      page={currentPage}
      currentStep={currentPage.step}
      content={content}
      backButton={false}
      nextButton={currentService && !loading}
      nextButtonLink={linkCheckSlash(location.pathname, currentService?.value)}
      loading={loading}
    />
  );
}
